export enum Atoms {
  Address = "Address",
  InternalAddress = "InternalAddress",
  internalGeoPosition="internalGeoPosition",
  geoposition="geoposition",
  InternalCart = "InternalCart",
  Inventory = "Inventory",
  Cart = "Cart",
  CartDetail = "CartDetail",
  IsLogin = "IsLogin",
  Profile = "Profile",
  OrderLastIds = "OrderLastIds",
  Connection = "Connection",
  Variant = "Variant",
  InternalVariant = "InternalVariant",
  InternalSelectedStore = "InternalSelectedStore",
  SelectedStore = "SelectedStore"
}
